<template>
  <div style="margin-left:10%;">
    <!-- <div class="banner page-head flex-box">
      <div class="w-100">
        <div class="container">
          <div class="banner-caption">
            <h3>iOS SDK Integration</h3>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row align-items-center justify-content-between">
      <!-- <div class="col-md-3" style="margin-top: 2%;margin-bottom:auto;">
        <a
          class="list-group-item list-group-item-action"
          href="#Intro"
          style="padding:0.55rem 1.25rem"
        >Introduction</a>
        <a
          style="padding:0.55rem 1.25rem"
          class="list-group-item list-group-item-action"
          href="#step1"
        >Access Microphone And Audio</a>
        <a
          style="padding:0.55rem 1.25rem"
          class="list-group-item list-group-item-action"
          href="#step2"
        >Usage</a>
        <a
          style="padding:0.55rem 1.25rem"
          class="list-group-item list-group-item-action"
          href="#step3"
        >Initialize the Chatbot</a>
      </div> -->
      <div class="col-md-12" style="margin-top: 2%;">
        <div id="Intro" style="margin-top:0.5%">
          <h2 class="documentation-header">Introduction</h2>
          <p style="margin-top:30px">
            Welcome to iOS Chatbot SDK
            <br />
            <br />The SDK provides a flexible set of methods that can be used in your iOS projects.
            <br />To invoke one of the below methods please be sure to call a method after embedding code on your page.
          </p>
        </div>
        <br />
        <br />
        <div class="row" style="margin-top:5px">
          <div class="col-md-11" id="step1">
            <h3 class="documentation-header">Access Microphone And Audio</h3>
            <p>Add following permissions to your info.plist file.</p>
            <pre style="margin-left:auto">
        &lt;xmp&gt;
        &lt;key&gt;NSMicrophoneUsageDescription&lt;/key&gt;
        &lt;string&gt;
        Speak and watch your words become text or say a color to see the box change colors.
        &lt;/string&gt;
        &lt;key&gt;NSSpeechRecognitionUsageDescription&lt;/key&gt;
        &lt;string&gt;Your speech will be detected after tapping the start button.&lt;/string&gt;
        &lt;/xmp&gt;
              </pre>
          </div>
        </div>
        <div class="row" style="margin-top:5px">
          <div class="col-md-11" id="step2">
            <h3 class="documentation-header">Usage</h3>
            <p>Add the "ChatBot" folder from the SDK to your project.</p>
          </div>
        </div>
        <div class="row" style="margin-top:5px">
          <div class="col-md-11" id="step3">
            <h3 class="documentation-header">Initialize the Chatbot</h3>
            <p>Add the following code to the events of buttons on which you want to load the chatbot. <strong>Make sure to provide a valid license key</strong></p>
            <pre style="margin-left:auto">
        let storyBoard = UIStoryboard(name: "ChatBot", bundle: Bundle.main)
        let popoverContent = storyBoard.instantiateViewController(withIdentifier: "ChatView") as! ChatViewController
        popoverContent.licenseKey = "YOUR_LICENSE_KEY_HERE"
        self.present(popoverContent, animated: true, completion: nil)
              </pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    function offsetAnchor() {
      if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 100);
      }
    }
    window.addEventListener("hashchange", offsetAnchor);
    window.setTimeout(offsetAnchor, 1);
  }
};
</script>

<style scoped>
.list-group-item {
  background-color: unset;
  border-width: 0px 0px 1px 0px;
}
pre {
  color: #ff1493;
  background: #F9FCFF 0% 0% no-repeat padding-box;
}
@media (max-width: 768px) {
  .col-md-3,
  .col-md-9 {
    padding-left: 4%;
    padding-right: 4%;
  }
}
@media (min-width: 768px) {
  .col-md-3 {
    padding-left: 2%;
  }
}
h6 {
  font: normal normal normal 1rem/2.5rem Poppins;
}
p {
  font: normal normal normal 1rem/1.45rem Poppins;
}
</style>
